import "./Cart.scss";
import {MdClose} from "react-icons/md";
import {BsCartDash} from "react-icons/bs";
import CartItem from "./CartItem/CartItem";
import { useContext } from "react";
import { Context } from "../../utils/context";
import  {loadStripe} from "@stripe/stripe-js"
import { makePaymentRequest } from "../../utils/api";
import { useNavigate,Link } from "react-router-dom";
import Products from "../Products/Products";


const Cart = ({setshowCart}) => {
    const navigate = useNavigate();
    const {cartItems,cartSubTotal} = useContext(Context)
    const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY)

    const handlePayment = async () => {
        
        try{
            const stripe = await stripePromise;
            const res = await makePaymentRequest.post("https://e-commerce-backend-ekqe.onrender.com/api/orders", {
                products: cartItems,
            });
    
            await stripe.redirectToCheckout({
                sessionId: res.data.stripeSession.id,
            })
        }catch(error){
            console.log(error);
        }
       
    }

    return (
        <div className="cart-panel">
            <div className="opac-layer">

            </div>
            <div className="cart-content">
                <div className="cart-header">
                    <span className="heading">Shopping Cart</span>
                
                <span className="close-btn" onClick={() => setshowCart(false)}>
                    <MdClose />
                    <span className="text">close</span>
                </span>
                </div>

                {!cartItems.length && <div className="empty-cart">
                    <BsCartDash />
                    <span>No products in the cart</span>
                   <Link to="/displayproduct"><button className="return-cart">Return to shop</button></Link> 
                </div>}

               {!!cartItems?.length && <>
                  <CartItem />
                  <div className="cart-footer">
                    <div className="subtotal">
                        <span className="text">Subtotal:</span>
                        <span className="text total">&#8377;{cartSubTotal}</span>
                    </div>
                    <div className="button">
                        <button className="checkout-cart" onClick={handlePayment}>Checkout</button>
                    </div>
                  </div>
                </>}

            </div>
        </div>
    );
};

export default Cart;
